<template>
  <div
    class="py-8px pr-10px flex justify-between items-center border-b-1px border-[#e6e6e6] microsoftYaHei"
  >
    <div
      class="text-hex-333 text-18px border-l-4px border-$portalPrimaryColor pl-10px flex-1 truncate !leading-23px"
    >
      {{ title }}
    </div>
    <div
      class="text-hex-1A1A1A text-14px cursor-pointer truncate"
      @click="loadMore"
      v-if="showMore"
    >
      更多
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColumnHeader',
  props: {
    title: {
      type: String,
      default: '新闻',
    },
    showMore: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    loadMore() {
      this.$emit('loadMore')
    },
  },
}
</script>

<style scoped lang="scss">
.microsoftYaHei {
  font-family: 'Microsoft YaHei regular';
}
</style>
